import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import QuestionsContainer from '../QuestionsContainer';
import GroupParentDisplay from '../GroupParentDisplay';
import ProfileSuggestionModal from '../../ProfileSuggestionModal';
import rankedTagImg from '../../../../assets/images/icons/ranked_tag.svg';
import { date } from '../../../dateUtils';
import { orderByStartDate } from '../../../arrayUtils';
import './AnswerRenderer.scss';
var renderValue = function renderValue(value) {
  if (value) {
    if (Array.isArray(value)) {
      return /*#__PURE__*/React.createElement("ul", null, value.map(function (item) {
        return /*#__PURE__*/React.createElement("li", {
          className: "fs-hide",
          key: item.label
        }, item.label);
      }));
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "fs-hide"
    }, value.label || value);
  }
  return null;
};
var rankedTagTooltip = /*#__PURE__*/React.createElement(Tooltip, {
  className: "proficiency-ranking-tag-tooltip",
  id: "proficiency-ranking-tooltip"
}, "Marked as top area by consultant");
var renderTag = function renderTag(tag) {
  var proficiency = tag.proficiency ? " (".concat(tag.proficiency, ")") : '';
  var tagLabel = "".concat(tag.label).concat(proficiency);
  if (tag.ranking) {
    return /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: rankedTagTooltip,
      key: "".concat(tag.label, "-overlay")
    }, /*#__PURE__*/React.createElement("span", {
      key: tag.label,
      className: "badge body-text-3 me-2 proficiency-ranking-tag"
    }, /*#__PURE__*/React.createElement("img", {
      src: rankedTagImg,
      alt: "Top Tag",
      height: "15",
      width: "10"
    }), tagLabel));
  }
  return /*#__PURE__*/React.createElement("span", {
    key: tag.label,
    className: "badge body-text-3 me-2 text-break"
  }, tagLabel);
};
var answerIdWithParent = function answerIdWithParent(answer) {
  return answer.parent_id ? [answer.parent_id, answer.id] : [answer.id];
};
var AnswerRenderer = /*#__PURE__*/function (_Component) {
  function AnswerRenderer(props) {
    var _this;
    _classCallCheck(this, AnswerRenderer);
    _this = _callSuper(this, AnswerRenderer, [props]);
    _this.state = {
      isHovering: false,
      showReadMore: false,
      showModal: false,
      editableIds: [],
      objectId: null,
      paginatedQuestionIds: [],
      truncateAnswers: props.truncateAnswers,
      pastRolesResData: [],
      forceRefreshKey: 0
    };
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleAppendTags = _this.handleAppendTags.bind(_this);
    _this.handleClearSuggestions = _this.handleClearSuggestions.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.setEditableIds = _this.setEditableIds.bind(_this);
    _this.handlePastRolesAfterUpdate = _this.handlePastRolesAfterUpdate.bind(_this);
    return _this;
  }
  _inherits(AnswerRenderer, _Component);
  return _createClass(AnswerRenderer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setShowReadMore();
    }
  }, {
    key: "setShowReadMore",
    value: function setShowReadMore() {
      var answer = this.props.answer;
      // Added 1 to clientHeight because in Safari 12.1 there is a rounding error leading
      // scrollHeight to be bigger than the clientHeight by 1 and so showReadMore is true
      if (answer.style === 'text_area') {
        this.setState({
          showReadMore: this.textAreaElement && this.textAreaElement.scrollHeight > this.textAreaElement.clientHeight + 1
        });
      }
    }
  }, {
    key: "setEditableIds",
    value: function setEditableIds() {
      var objectId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var answer = this.props.answer;
      var editableIds = answerIdWithParent(answer);
      var paginatedQuestionIds = this.buildPaginatedIdsList(editableIds);
      this.setState({
        editableIds: editableIds,
        objectId: objectId,
        paginatedQuestionIds: paginatedQuestionIds,
        showModal: true
      });
    }

    // resulting has the shape: [ [firstPageQuestions...], [secondPageQuestions...], ... ]
  }, {
    key: "buildPaginatedIdsList",
    value: function buildPaginatedIdsList(firstPageQuestions) {
      var _this$props = this.props,
        paginated = _this$props.paginated,
        childrenQuestionIds = _this$props.childrenQuestionIds;
      if (paginated) {
        var paginatedQuestionIds = [];
        // currently assumes one page per child question.
        paginatedQuestionIds.push(firstPageQuestions);
        childrenQuestionIds.forEach(function (q) {
          return paginatedQuestionIds.push([q]);
        });
        return paginatedQuestionIds;
      }
      return [];
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      var _this$props2 = this.props,
        closeModalCallback = _this$props2.closeModalCallback,
        answer = _this$props2.answer;
      this.setState({
        showModal: false
      }, function () {
        closeModalCallback(answer);
      });
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver() {
      this.setState({
        isHovering: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        isHovering: false
      });
    }
  }, {
    key: "handleAppendTags",
    value: function handleAppendTags() {
      var _this$props3 = this.props,
        answer = _this$props3.answer,
        updateSuggestedTags = _this$props3.updateSuggestedTags;
      this.handleCloseModal(answer);
      updateSuggestedTags([], answer.association_model);
    }
  }, {
    key: "handleClearSuggestions",
    value: function handleClearSuggestions(tagIds) {
      var _this$props4 = this.props,
        updateSuggestedTags = _this$props4.updateSuggestedTags,
        suggestedTags = _this$props4.suggestedTags,
        answer = _this$props4.answer;
      var filteredTags = suggestedTags.filter(function (tag) {
        return !tagIds.includes(tag.id);
      });
      updateSuggestedTags(filteredTags, answer.association_model);
    }
  }, {
    key: "handlePastRolesAfterUpdate",
    value: function handlePastRolesAfterUpdate(data) {
      // this will update past roles view after edit and update
      var forceRefreshKey = this.state.forceRefreshKey;
      this.setState({
        pastRolesResData: data,
        forceRefreshKey: forceRefreshKey + 1
      });
    }
  }, {
    key: "renderEdit",
    value: function renderEdit() {
      var _this2 = this;
      var objectId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var renderAddQuestionKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props5 = this.props,
        answer = _this$props5.answer,
        fullView = _this$props5.fullView,
        editMode = _this$props5.editMode,
        suggestedTags = _this$props5.suggestedTags;
      var isHovering = this.state.isHovering;
      var isPastRole = answer.question_type === 'past_roles';
      if (fullView && renderAddQuestionKey) {
        return /*#__PURE__*/React.createElement("a", {
          className: "edit-attribute modal-anchor-trigger add-answer medium-weight ".concat(isPastRole ? 'body-text-2' : 'body-text-3'),
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            return _this2.setEditableIds();
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-plus"
        }), "Add ".concat(isPastRole ? 'Role' : answer.question_key));
      }
      if (fullView && (isHovering || editMode) && suggestedTags.length === 0) {
        return /*#__PURE__*/React.createElement("a", {
          className: "edit-attribute",
          tabIndex: 0,
          role: "button",
          onClick: function onClick() {
            return _this2.setEditableIds(objectId);
          }
        }, "Edit");
      }
      return null;
    }
  }, {
    key: "renderDisplayFreeText",
    value: function renderDisplayFreeText(questionKey, answer) {
      var _this3 = this;
      var showReadMore = this.state.showReadMore;
      var isReadingMore = this.props.isReadingMore;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(questionKey, "-answer-container")
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-4 ".concat(questionKey)
      }, questionKey, /*#__PURE__*/React.createElement("span", {
        className: "body-text-2"
      }, answer && this.renderEdit())), /*#__PURE__*/React.createElement("div", {
        className: "fs-hide body-text-2 text-read-more ".concat(isReadingMore ? 'show' : 'overflow'),
        ref: function ref(el) {
          _this3.textAreaElement = el;
        }
      }, questionKey === 'Linkedin' && answer ? /*#__PURE__*/React.createElement("a", {
        href: /^https?:\/\//i.test(answer) ? answer : "https://".concat(answer),
        target: "_blank",
        rel: "noreferrer"
      }, "Visit LinkedIn Profile") : answer), !answer && this.renderEdit(null, true), showReadMore && /*#__PURE__*/React.createElement("div", {
        className: "align"
      }, /*#__PURE__*/React.createElement("a", {
        className: "body-text-2",
        tabIndex: 0,
        role: "link",
        onClick: this.readMore
      }, isReadingMore ? 'Read less' : 'Read more')));
    }
  }, {
    key: "renderDisplayResume",
    value: function renderDisplayResume(questionKey, answer) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: "mb-4 ".concat(questionKey)
      }, questionKey, /*#__PURE__*/React.createElement("span", {
        className: "body-text-2"
      }, answer && this.renderEdit())), /*#__PURE__*/React.createElement("div", {
        className: "resume-name mb-4"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/resumes/".concat(answer.resource_id),
        target: "_blank",
        rel: "noreferrer"
      }, answer.document_file_name)));
    }
  }, {
    key: "renderDisplayManyTags",
    value: function renderDisplayManyTags(questionKey, answer, modelName) {
      var _this$props6 = this.props,
        csrfToken = _this$props6.csrfToken,
        editMode = _this$props6.editMode,
        showSuggestionModal = _this$props6.showSuggestionModal,
        fullView = _this$props6.fullView;
      var suggestedTags = this.props.suggestedTags;
      if (Array.isArray(answer)) {
        if (!fullView && answer.length === 0) {
          return null;
        }
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "medium-weight ".concat(answer.length === 0 && 'mb-2')
        }, questionKey, fullView && suggestedTags.length > 0 && /*#__PURE__*/React.createElement(ProfileSuggestionModal, {
          tags: suggestedTags,
          csrfToken: csrfToken,
          appendTags: this.handleAppendTags,
          clearTags: this.handleClearSuggestions,
          answerState: answer,
          editMode: editMode,
          forceShow: showSuggestionModal === modelName
        }), answer.length > 0 && this.renderEdit()), answer.map(function (tag) {
          return renderTag(tag);
        }), answer.length === 0 && this.renderEdit(null, true));
      }
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "title medium-weight mb-4 mute"
      }, questionKey, answer.length > 0 && this.renderEdit()), /*#__PURE__*/React.createElement("span", {
        className: "body-text-3 mute"
      }, answer));
    }
  }, {
    key: "renderList",
    value: function renderList(questionKey, answer, isReadingMore) {
      var readingMoreThreshhold = this.props.readingMoreThreshhold;
      if (answer.length === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "body-text-2"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "mb-2"
        }, questionKey), this.renderEdit(null, true));
      }
      var answ = answer;
      if (!isReadingMore) {
        answ = answer.slice(0, readingMoreThreshhold);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "list body-text-2"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-4"
      }, questionKey, /*#__PURE__*/React.createElement("span", {
        className: "body-text-2"
      }, this.renderEdit())), /*#__PURE__*/React.createElement("ul", null, answ.map(function (item) {
        return /*#__PURE__*/React.createElement("li", {
          key: item
        }, item);
      })));
    }
  }, {
    key: "renderDisplayValue",
    value: function renderDisplayValue(questionKey, answer) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "title medium-weight"
      }, questionKey, this.renderEdit()), renderValue(answer));
    }
  }, {
    key: "renderDisplayNumericRange",
    value: function renderDisplayNumericRange(questionKey, answer) {
      if (!answer.low && !answer.high) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "title medium-weight"
        }, questionKey), this.renderEdit(null, true));
      }
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "title medium-weight"
      }, questionKey, this.renderEdit()), answer.low.length > 0 && answer.high.length > 0 ? "$".concat(answer.low, " - $").concat(answer.high, "/hr") : "$".concat(answer.low).concat(answer.high, "/hr"));
    }
  }, {
    key: "renderNullAnswer",
    value: function renderNullAnswer(questionKey) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: "mb-4 ".concat(questionKey)
      }, questionKey), this.renderEdit(null, true));
    }
  }, {
    key: "renderPastRoles",
    value: function renderPastRoles(answer) {
      var _this4 = this;
      var _this$props7 = this.props,
        fullView = _this$props7.fullView,
        isReadingMore = _this$props7.isReadingMore,
        readingMoreThreshhold = _this$props7.readingMoreThreshhold;
      var pastRolesResData = this.state.pastRolesResData;
      if (answer.length === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "body-text-2"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "mb-2"
        }, "Past Roles"), this.renderEdit(null, true));
      }
      var orderedPastRoles = orderByStartDate(pastRolesResData.length ? pastRolesResData : answer);
      if (!isReadingMore) {
        orderedPastRoles = orderedPastRoles.slice(0, readingMoreThreshhold);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-4"
      }, /*#__PURE__*/React.createElement("span", {
        className: "past-roles-title me-3"
      }, "Past Roles"), this.renderEdit(null, true)), /*#__PURE__*/React.createElement("div", {
        className: "mt-3"
      }, orderedPastRoles.map(function (pastRole) {
        return /*#__PURE__*/React.createElement("div", {
          key: pastRole.id,
          className: "past-role"
        }, /*#__PURE__*/React.createElement("div", {
          className: "fs-hide medium-weight"
        }, pastRole.title, _this4.renderEdit(pastRole.id)), /*#__PURE__*/React.createElement("div", {
          className: "fs-hide"
        }, pastRole.role), /*#__PURE__*/React.createElement("div", {
          className: "fs-hide"
        }, pastRole.company_name), isReadingMore && /*#__PURE__*/React.createElement("div", {
          className: "fs-hide body-text-2 text-read-more show"
        }, pastRole.description), !answer && _this4.renderEdit(null, true), fullView ? /*#__PURE__*/React.createElement("div", {
          className: "mute fs-hide"
        }, date(pastRole.start_date, pastRole.end_date, pastRole.current)) : /*#__PURE__*/React.createElement("div", {
          className: "mute fs-hide"
        }, pastRole.experience));
      })));
    }
  }, {
    key: "renderGroupParent",
    value: function renderGroupParent(questionKey, answer, isReadingMore) {
      if (answer.length === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "body-text-2"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "mb-2"
        }, questionKey), this.renderEdit(true));
      }
      if (answer === 'Not Applicable') {
        return /*#__PURE__*/React.createElement("div", {
          className: "body-text-3 mute"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "mb-3"
        }, questionKey, /*#__PURE__*/React.createElement("span", {
          className: "body-text-2"
        }, this.renderEdit())), "Not Applicable");
      }
      var answ = answer;
      if (!isReadingMore) {
        answ = answer.slice(0, 2);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-4"
      }, questionKey, /*#__PURE__*/React.createElement("span", {
        className: "body-text-2"
      }, this.renderEdit())), /*#__PURE__*/React.createElement(GroupParentDisplay, {
        answers: answ,
        questionKey: questionKey,
        key: questionKey
      }));
    }
  }, {
    key: "renderAnswer",
    value: function renderAnswer() {
      var _this$props8 = this.props,
        isReadingMore = _this$props8.isReadingMore,
        answer = _this$props8.answer;
      if (answer.answer === null) {
        return this.renderNullAnswer(answer.question_key);
      }
      switch (answer.question_type) {
        case 'select_many':
        case 'select_one':
        case 'only_custom_tags':
          if (answer.style === 'radio_oneline') {
            return this.renderDisplayValue(answer.question_key, answer.answer);
          }
          return this.renderDisplayManyTags(answer.question_key, answer.answer, answer.association_model);
        case 'freetext':
        case 'location':
          return this.renderDisplayFreeText(answer.question_key, answer.answer);
        case 'numeric_range':
          return this.renderDisplayNumericRange(answer.question_key, answer.answer);
        case 'file':
          if (answer.style === 'resume') {
            return this.renderDisplayResume(answer.question_key, answer.answer, answer.resume_url);
          }
          break;
        case 'past_roles':
          return this.renderPastRoles(answer.answer);
        case 'list':
          return this.renderList(answer.question_key, answer.answer, isReadingMore);
        case 'group_parent':
          return this.renderGroupParent(answer.question_key, answer.answer, isReadingMore);
        default:
          return null;
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
        editable = _this$props9.editable,
        fullView = _this$props9.fullView,
        hideFooterButton = _this$props9.hideFooterButton,
        questionnaireName = _this$props9.questionnaireName,
        questionableId = _this$props9.questionableId,
        questionableType = _this$props9.questionableType,
        csrfToken = _this$props9.csrfToken,
        answer = _this$props9.answer,
        paginated = _this$props9.paginated,
        handleNewResume = _this$props9.handleNewResume,
        isReadingMore = _this$props9.isReadingMore;
      var _this$state = this.state,
        showModal = _this$state.showModal,
        paginatedQuestionIds = _this$state.paginatedQuestionIds,
        editableIds = _this$state.editableIds,
        objectId = _this$state.objectId,
        forceRefreshKey = _this$state.forceRefreshKey;
      var answerDisplay = !fullView && (answer.answer === null || answer.answer.length === 0) ? null : /*#__PURE__*/React.createElement("div", {
        className: "answer full-width body-text-2",
        onMouseOver: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave
      }, this.renderAnswer());
      if (editable) {
        return /*#__PURE__*/React.createElement("div", {
          className: "answer full-width"
        }, answerDisplay, /*#__PURE__*/React.createElement(QuestionsContainer, {
          key: editableIds.join('+') + forceRefreshKey,
          questionnaireName: questionnaireName,
          questionIds: editableIds,
          objectId: objectId,
          questionType: answer.question_type,
          questionableId: questionableId,
          questionableType: questionableType,
          csrfToken: csrfToken,
          modalOpen: showModal,
          hideFooterButton: hideFooterButton || answer.question_type === 'group_parent',
          withModal: true,
          paginated: paginated,
          paginatedQuestionIds: paginatedQuestionIds,
          closeModalCallback: this.handleCloseModal,
          handleNewResume: handleNewResume,
          forceCloseButton: answer.question_type === 'past_roles',
          isReadingMore: isReadingMore,
          handlePastRolesAfterUpdate: this.handlePastRolesAfterUpdate
        }));
      }
      return answerDisplay;
    }
  }]);
}(Component);
AnswerRenderer.propTypes = {
  answer: PropTypes.shape({}).isRequired,
  fullView: PropTypes.bool,
  editMode: PropTypes.bool,
  isReadingMore: PropTypes.bool,
  suggestedTags: PropTypes.arrayOf(PropTypes.shape({})),
  updateSuggestedTags: PropTypes.func,
  csrfToken: PropTypes.string,
  showSuggestionModal: PropTypes.string,
  questionableType: PropTypes.string,
  questionableId: PropTypes.number,
  closeModalCallback: PropTypes.func,
  questionnaireName: PropTypes.string,
  hideFooterButton: PropTypes.bool,
  editable: PropTypes.bool,
  paginated: PropTypes.bool,
  childrenQuestionIds: PropTypes.arrayOf(PropTypes.number),
  handleNewResume: PropTypes.func,
  truncateAnswers: PropTypes.bool,
  readingMoreThreshhold: PropTypes.number
};
AnswerRenderer.defaultProps = {
  fullView: false,
  updateSuggestedTags: function updateSuggestedTags() {
    return null;
  },
  editMode: false,
  isReadingMore: true,
  suggestedTags: [],
  csrfToken: null,
  showSuggestionModal: '',
  editable: false,
  childrenQuestionIds: [],
  paginated: false,
  handleNewResume: function handleNewResume() {},
  truncateAnswers: false,
  readingMoreThreshhold: 2
};
export default AnswerRenderer;